import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AdditionalMethodsService } from 'src/app/services/additional-methods.service';

@Component({
  selector: 'app-education-guidance',
  templateUrl: './education-guidance.component.html',
  styleUrls: ['./education-guidance.component.css']
})
export class EducationGuidanceComponent implements OnInit {

  breakpoint: number;
  gutter: string;
  emailForm: FormGroup;

  dataTool = {
    title: 'Translation tool',
    description: 'EDIE provides this tool to enable users to convert text to voice and vice versa, using their built-in tool.'
  };

  constructor(private router: Router,
              public additionalMethods: AdditionalMethodsService, 
              private fb: FormBuilder, private http: HttpClient) {
                this.emailForm = this.fb.group({
                  toEmail: ['', [Validators.required, Validators.email]],
                  subject: ['', Validators.required],
                  message: ['', Validators.required]
                });
               }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    if (window.innerWidth <= 576) {
      this.breakpoint = 1;
      // this.gutter = '2px';
    } else if (window.innerWidth <= 992) {
      this.breakpoint = 2;
      // this.gutter = '5px';
    } else if (window.innerWidth <= 1200) {
      this.breakpoint = 3;
      // this.gutter = '8px';
    } else {
      this.breakpoint = 4;
    }
  }

  onResize(event: any) {
    if (event.target.innerWidth <= 576) {
      this.breakpoint = 1;
    } else if (event.target.innerWidth <= 992) {
      this.breakpoint = 2;
    } else if (event.target.innerWidth <= 1200) {
      this.breakpoint = 3;
    } else {
      this.breakpoint = 4;
    }
  }

}
